module.exports = __webpack_public_path__ + "static/media/loading.3c4791e8.gif";